import KycService from "../../services/kyc-service";
import { KYC_DEFAULT_FILTER_PAYLOAD } from "./kycDesignShared";
import { getKycAppliedFilterPayload } from "./kycHelpers";

export const parseQuotationMasterListResponse = (response) => {
	const success = response?.data?.statusCode === 200 || response?.data?.status === true;
	if (!success) {
		return [];
	}
	const responseData = response.data.responseData || {};
	const quotationList = Array.isArray(responseData)
		? responseData
		: responseData.quotationMasterLists ||
			responseData.quotationMasterList ||
			responseData.kycQuotationMasterLists ||
			responseData.quotationList ||
			responseData.data ||
			[];
	return Array.isArray(quotationList) ? quotationList : [];
};

export const parseQuotationMasterTableResponse = (response, fallbackPage = 1) => {
	const rows = parseQuotationMasterListResponse(response);
	const responseData = response?.data?.responseData || {};
	const totalRecords = Number(
		Array.isArray(responseData) ? rows.length : responseData.totalRecords || rows.length || 0
	);
	const rawPage = Array.isArray(responseData) ? undefined : responseData.currentPage;
	const parsedPage = Number(rawPage);
	const currentPage =
		rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
			? parsedPage
			: fallbackPage;
	return { rows, totalRecords, currentPage };
};

export const fetchQuotationMasterList = async ({
	ispl_product = "",
	customer = "",
	crmGuid = "",
	search = "",
	pageindex = 1,
	pagesize = 10,
	sortcolumn = "createdOn",
	orderBy = "DESC",
	groupCompanyId = "",
} = {}) => {
	const requestData = {
		pageindex,
		pagesize,
		sortcolumn: sortcolumn || "",
		orderBy: orderBy || "",
		search: String(search || "").trim(),
		...KYC_DEFAULT_FILTER_PAYLOAD,
		...getKycAppliedFilterPayload(),
	};
	const trimmedProduct = String(ispl_product || "").trim();
	const trimmedCustomer = String(customer || "").trim();
	const trimmedCrmGuid = String(crmGuid || "").trim();

	if (trimmedProduct) {
		requestData.ispl_product = trimmedProduct;
	}
	if (trimmedCustomer) {
		requestData.customer = trimmedCustomer;
	}
	if (trimmedCrmGuid) {
		requestData.crmGuid = trimmedCrmGuid;
		requestData.CrmGuid = trimmedCrmGuid;
	}

	const trimmedGroupCompanyId = String(groupCompanyId || "").trim();
	if (trimmedGroupCompanyId) {
		requestData.groupcomanyId = trimmedGroupCompanyId;
	}
	const response = await KycService.getKycQuotationMasterListAPI(requestData);
	return parseQuotationMasterTableResponse(response, pageindex);
};
